import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import Gbtn from "../../../Components/buttons/Gbtn";
import DashNav from "../../../Components/DashNav/DashNav";
import { FiEdit } from "react-icons/fi";
import { deleteTeam, getAllTeam } from "../../../api";
import { RiSignalWifiErrorLine, RiDeleteBin6Line } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Components/LoadingSpinner/LoadingSpinner";
import ModalComp from "../../../Components/modal/ModalComp";
import noImage from "../../../Assests/avatar1.png";
import { MdPeople } from "react-icons/md";

export default function Team() {
    const icon = () => {
        return <MdPeople size="28" fill="#DF2F35" />;
    };

    const location = useLocation();
    const CurrPage =
        location.state && location.state ? location.state.page : null;

    const navigate = useNavigate("");

    const [page, setPage] = useState(CurrPage !== null ? CurrPage : 1);
    const [limit, setLimit] = useState(10);
    const [totalRecords, setTotalRecords] = useState(10);
    const [teamData, setTeamData] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [paginationDisplay, setPaginationDisplay] = useState("block");
    const [err, setErr] = useState(false);
    const [searchString, setSearchString] = useState("");


    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        fetchData(page);
    }, []);

    useEffect(() => {
        const delay = setTimeout(() => {
            if (searchString.trim() !== "") fetchData(page, searchString);
        }, 1500);
        return () => {
            clearTimeout(delay);
        };
    }, [searchString]);

    const fetchData = (pageNumber, searchTxt) => {
        setisLoading(true);
        setErr(false);
        getAllTeam(limit, pageNumber, searchTxt)
            .then(({ data }) => {
                console.log('data nesss', data)
                setisLoading(false);
                if (data.error_code == 0) {
                    setTeamData(data.result);
                    setTotalRecords(data.total_records);
                    setPaginationDisplay("block");
                    setPage(pageNumber);
                } else if (data.error_code === 2) {
                    setTeamData(data.result);
                    setErrorMsg(data.message);
                } else {
                    setErr(true);
                    setErrorMsg(data.message);
                }

            })
            .catch((err) => {
                console.log("err", err);
                setErr(true);
                setPaginationDisplay("none");
                setErrorMsg(`Network Error! ${err.message}`);
                setisLoading(false);
            });
    };

    const handlePageChange = (pageNumber) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        if (pageNumber >= 1) {
            fetchData(pageNumber, searchString);
        }
    };

    const handleSearch = (e) => {
        setSearchString(e.target.value);
        if (e.target.value === "") {
            fetchData(page);
        }
    };

    return (
        <>
            <div className="mainDashView">
                <div>
                    <DashNav svg={icon} DashboardNavText="Team" />
                </div>

                <div className="dashPanel border-lt-Gray">
                    <div className="r-ViewBar">
                        <div className="r-ViewBar2">
                            <div>
                                <input
                                    type="search"
                                    value={searchString}
                                    onChange={handleSearch}
                                    placeholder="Search"
                                    className="rolesSearch"
                                />
                            </div>
                        </div>
                        <div className="r-View-btn">
                            <Gbtn
                                text="Add"
                                color="#DF2F35"
                                radius="5px"
                                width="200px"
                                func={() => navigate("/dashboard/team/add")}
                            />
                        </div>
                    </div>
                    {isLoading ? (
                        <LoadingSpinner />
                    ) : err ? (
                        <div className="network-err-msg">
                            <RiSignalWifiErrorLine /> {errorMsg}
                        </div>
                    ) : teamData && teamData ? (
                        <div className="tableContainer">
                            <table className="roleViewTable" style={{ width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th>Actions</th>
                                        <th>Photo</th>
                                        <th>Name</th>
                                        <th>Designation</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {teamData?.map((data) => (
                                        <Rows data={data} currentPage={page} setTeamData={id => {
                                            let newData = teamData.filter(data => data.id != id);
                                            setTeamData(() => newData)
                                        }} />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="network-err-msg">{errorMsg}</div>
                    )}
                    <div className="paginationDiv" style={{ display: paginationDisplay }}>
                        <Pagination
                            activePage={page}
                            itemsCountPerPage={limit}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={3}
                            onChange={(pageNumber) => {
                                handlePageChange(pageNumber);
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
const Rows = ({ data, currentPage, setTeamData }) => {
    const navigate = useNavigate();
    let DataId = data.id;
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isModalLoading, setIsModalLoading] = useState(false)
    const [err, setErr] = useState(false)
    const [imgErr, setImgErr] = useState(false);


    const editRole = () => {
        navigate("/dashboard/team/edit", {
            state: { editData: data, page: currentPage },
        });
    };
    const delRole = () => {
        setIsModalLoading(true)
        deleteTeam({ id: data?.id }).then(({ data }) => {
            setIsModalLoading(false)
            if (data.error_code == 0 || data.error_code == 1) {
                setTeamData(DataId)
                setIsModalOpen(false)
            }
            else if (data.error_code == 2) {
                setErr(true)
            }
            else {
                setErr(true)
            }
        }).catch(err => {

            setIsModalLoading(false)
            setErr(true);
        })
    };

    const handleImageErr = () => {
        setImgErr(true);
    };

    return (
        <>
            <ModalComp isVisible={isModalOpen} setIsVisible={setIsModalOpen} onCnfrm={delRole} isLoading={isModalLoading} isErr={err} />
            {data && data ? (
                <tr>
                    <td
                        style={{
                            minWidth: "50px",
                        }}
                    >
                        <div style={{ display: "flex", justifyContent: 'center', margin: "0 15px" }}>
                            <button onClick={editRole} className="Actionbtn editBtn">
                                <FiEdit />
                            </button>
                            <button onClick={() => setIsModalOpen(true)} className="Actionbtn delBtn">
                                <RiDeleteBin6Line />
                            </button>
                        </div>
                    </td>

                    <td>
                        <img
                            src={imgErr ? noImage : baseUrl + data.image_path}
                            onError={handleImageErr}
                            alt=""
                            height={"38"}
                            width={"38"}
                            style={{
                                borderRadius: "100%",
                                border: "1px solid lightgray",
                                borderBlockColor: "lightgray",
                            }}
                        />
                    </td>
                    <td className="break-line-100">{data?.name?.length > 50 ? data?.name.substring(0, 46) + '...' : data?.name}</td>
                    <td className="break-line-200">{data?.designation?.length > 160 ? data?.designation.substring(0, 156) + '...' : data?.designation}</td>
                    {/* <td className="break-line-300">{data?.description?.length > 460 ? data?.description.substring(0, 458) + '...' : data?.description}</td> */}
                    <td
                        className="break-line-300"
                        style={{ padding: "0 30px" }}
                        dangerouslySetInnerHTML={{
                            __html:
                                data?.description &&
                                    data?.description.length > 300
                                    ? data?.description.substring(0, 300) + "..."
                                    : data?.description,
                        }}
                    ></td>
                </tr>
            ) : null}
        </>
    );
};


